// extracted by mini-css-extract-plugin
export default {"content":"Privacy_style_content__zYK9h","rotate":"Privacy_style_rotate__cJdV0"};